export const isDefined = <T>(value: Maybe<T>): value is T => {
    return value !== undefined;
};
